import {createAction, props} from '@ngrx/store';

export enum MaintenanceModeActions {
  MaintenanceMode = '[Maintenance Mode Component] Set Maintenance Mode',
}

export const maintenanceMode = createAction(
  MaintenanceModeActions.MaintenanceMode,
  props<{MaintenanceModeStatus: boolean}>()
);
